/**
 * @generated SignedSource<<abeba7fda5392a7c500282bb0fb3e646>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConnectSlackUserInput = {
  token: string;
};
export type SlackConnectPageConnectSlackUserMutation$variables = {
  input: ConnectSlackUserInput;
};
export type SlackConnectPageConnectSlackUserMutation$data = {
  readonly connectSlackUser: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type SlackConnectPageConnectSlackUserMutation = {
  response: SlackConnectPageConnectSlackUserMutation$data;
  variables: SlackConnectPageConnectSlackUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConnectSlackUserPayload",
    "kind": "LinkedField",
    "name": "connectSlackUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackConnectPageConnectSlackUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackConnectPageConnectSlackUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "22827af6c9fd5ce0e694a0424d01ad12",
    "id": null,
    "metadata": {},
    "name": "SlackConnectPageConnectSlackUserMutation",
    "operationKind": "mutation",
    "text": "mutation SlackConnectPageConnectSlackUserMutation(\n  $input: ConnectSlackUserInput!\n) {\n  connectSlackUser(input: $input) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "5844f117673f5cd99e3132d186ba9ffe";

export default node;
